import { useQuery } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';

export function useMovements(filters = {}) {
  const params = {
    page: filters.page || 1,
    limit: filters.limit || 30
  };
  if (filters.productId) params.productId = filters.productId;
  if (filters.warehouseId) params.warehouseId = filters.warehouseId;
  if (filters.type) params.type = filters.type;
  if (filters.from) params.from = filters.from;
  if (filters.to) params.to = filters.to;

  return useQuery({
    queryKey: ['inventory', 'movements', params],
    queryFn: async () => {
      const { data } = await api.get('/purchases/movements', { params });
      return {
        items: data?.items || [],
        total: data?.total || 0,
        page: data?.page || 1,
        pages: data?.pages || 1,
        limit: data?.limit || 30
      };
    },
    keepPreviousData: true,
    staleTime: 15_000
  });
}
